import { generateOpenApi } from '@ts-rest/open-api';
import { jobManagementContract } from './jobManagement.contract.js';

export const settingsOpenApiSpec = generateOpenApi(
  jobManagementContract,
  {
    info: {
      title: 'Skewb Works Settings API',
      version: '1.0.0',
      description:
        'Type-safe settings API for Skewb Works Lite. Covers job category, task type, and category-task assignment management.',
      contact: {
        name: 'Skewb Works Development Team',
      },
    },
    servers: [
      {
        url: 'https://localhost:8080',
        description: 'Local development server',
      },
      {
        url: 'https://api.works-works-lite.dev.skewbdigital.co.uk',
        description: 'Dev API server',
      },
    ],
    tags: [
      {
        name: 'Settings',
        description: 'Job management configuration endpoints (categories, task types, assignments)',
      },
    ],
  },
  {
    setOperationId: true,
    operationMapper: (operation) => ({
      ...operation,
      tags: ['Settings'],
    }),
  },
);
